import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { Button, Form, Table, Spin, Input, Select, Upload, Popconfirm, Tag, InputNumber, Space, DatePicker } from "antd";
import moment from "moment";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import { searchProduct } from "../../redux/actions/searchProduct.action";
import { sendProduct } from "../../redux/actions/sendProductToBergen.action";
import notification from "../../utils/notification";
import { SearchOutlined, FilterFilled, UploadOutlined, PaperClipOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { getVendors } from "../../redux/actions/vendor.action";
import { deleteExpenseBillAttachments, getAllExpenseBillAttachments, updateExpenseBillAttachments, uploadExpenseBillAttachments } from "../../redux/actions/expenseBill.action";
import axios from "axios";
import { BASEURL } from "../../constant/config";

const { Option } = Select;

const ExpenseBillAttachment = () => {
  TabTitle("Expense Bill Attachment");
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const dispatch = useDispatch();
  const token = ReadCookie("token");

  const [controlSheet, setControlSheet] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [excelData, setExcelData] = useState([]);

  const [data, setData] = useState([]);
  const [getAllVendors, setGetAllVendors] = useState([]);
  const [isedit, setIsEdit] = useState(false);

  const [billStatus, setBillStatus] = useState("UNPAID");


  const tableRef = useRef(null);
  const { controlLog, vendor } = useSelector((state) => state);




  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "File Name",
      dataIndex: "physical_file_name",
      key: "physical_file_name",
      sorter: (a, b) =>
        a.physical_file_name?.localeCompare(b.physical_file_name),
    },
    {
      title: "File Type",
      dataIndex: "upload_file_type",
      key: "upload_file_type",
      render: (type) => (
        <Tag color={"success"}>
          {type ? type : "----"}
        </Tag>
      ),

    },
    {
      title: "Vendor ID",
      dataIndex: "vendor_id",
      key: "vendor_id",
    },
    {
      title: "Vendor Name",
      dataIndex: "vendor_name",
      key: "vendor_name",
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      render: (text) => (text ? moment(text).format("MM-DD-YYYY") : "-"),
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",

      render: (text, record) => (
        record.is_edit ? (
          <DatePicker
            size="small"
            format="MM-DD-YYYY"
            value={record.due_date ? moment(record.due_date) : null}
            onChange={(value) => {

              if (value) {
                setData((prev) =>
                  prev.map((item) =>
                    item.vendor_communication_id ===
                      record.vendor_communication_id
                      ? {
                        ...item,
                        due_date: value,
                      }
                      : item
                  )
                );
              }
            }}
            style={{ width: "100%" }}
          />
        ) : (
          text ? moment(text).format("MM-DD-YYYY") : "-"
        )
      ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "is_active",
    //   key: "is_active",
    //   render: (isActive) => (
    //     <Tag color={isActive ? "success" : "error"}>
    //       {isActive ? "PROCESSED" : "PENDING"}
    //     </Tag>
    //   ),
    // },
    {
      title: "Bill Amount",
      dataIndex: "bill_amount",
      key: "bill_amount",
      render: (text, record) => (
        record.is_edit ? (
          <InputNumber
            value={record.bill_amount ?? null}
            min={0}
            step={0.01}
            precision={2}
            style={{ width: "100%" }}
            onChange={(value) => {
              setData((prev) =>
                prev.map((item) =>
                  item.vendor_communication_id ===
                    record.vendor_communication_id
                    ? {
                      ...item,
                      bill_amount: value,
                    }
                    : item
                )
              );
            }}
          />
        ) : text

      ),
    },
    {
      title: "Approval Amount",
      dataIndex: "approval_amount",
      key: "approval_amount",
      render: (text, record) => (
        record.is_edit ? (
          <InputNumber
            value={record.approval_amount ?? null}
            min={0}
            step={0.01}
            precision={2}
            style={{ width: "100%" }}
            onChange={(value) => {
              setData((prev) =>
                prev.map((item) =>
                  item.vendor_communication_id ===
                    record.vendor_communication_id
                    ? {
                      ...item,
                      approval_amount: value,
                    }
                    : item
                )
              );
            }}
          />
        ) : text

      ),
    },
    {
      title: "Reference No #",
      dataIndex: "reference_no",
      key: "reference_no",
      render: (text, record) => (
        record.is_edit ? (
          <Input
            value={record.reference_no || ""}
            onChange={(event) => {
              let copyArr = [...data];

              copyArr.forEach((item) => {
                if (
                  item.vendor_communication_id ===
                  record.vendor_communication_id
                ) {
                  item.reference_no = event.target.value;
                }
              });

              setData(copyArr);
            }}
          />
        ) : text

      ),
    },
    {
      title: "Bill Expense Amount",
      dataIndex: "bill_expense_amount",
      key: "bill_expense_amount",
      render: (text, record) => (text ? numeral(text).format("0,0.00") : "-"),
    },
    {
      title: "Bill Payment Amount",
      dataIndex: "bill_payment_amount",
      key: "bill_payment_amount",
      render: (text, record) => (text ? numeral(text).format("0,0.00") : "-"),
    },
    {
      title: "Bill Status",
      dataIndex: "billstatus",
      key: "billstatus",
      render: (text) => (
        <Tag color={text === "PAID" ? "success" : "error"}>
          {text ? text : "----"}
        </Tag>
      ),

    },
    {
      title: "Download Link",
      dataIndex: "upload_file_url",
      key: "upload_file_url",
      render: (url, record) => (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1890ff", fontWeight: 500 }}
        >
          View File
        </a>
      ),
    },
    // {
    //   title: "Change Status",
    //   dataIndex: "",
    //   key: "",
    //   // width: "300px",
    //   render: (url, record) => (
    //     <Popconfirm
    //       disabled={record.is_active}
    //       title="Are you sure you want to change the status of this Attachment?"
    //       onConfirm={() => {
    //         let payload = {
    //           vendor_communication_id: record.vendor_communication_id,
    //           is_active: !record.is_active,
    //           bill_amount: record.bill_amount,
    //           approval_amount: record.approval_amount,
    //           reference_no: record.reference_no ?? "",
    //         }
    //         dispatch(updateExpenseBillAttachments(token, payload))
    //           .then((res) => {
    //             notification("success", "Attachment Updated Successfully");
    //             dispatch(getAllExpenseBillAttachments(token)).then((res) => {
    //               setData(res?.payload?.data);
    //             });
    //           })
    //           .catch((err) => {
    //             notification("error", "Failed to Update Attachment");
    //           });
    //       }}
    //       okText="Yes"
    //       cancelText="No"
    //     >
    //       {
    //         !record.is_active && (
    //           <Button
    //             disabled={record.is_active}
    //           >
    //             PROCESSED
    //           </Button>
    //         )
    //       }

    //     </Popconfirm>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      render: (url, record) => (
        <>
          <Space>
            {
              record?.is_edit ? (
                <Popconfirm
                  // disabled={record.is_active}
                  title="Are you sure you want to update this Attachment?"
                  onConfirm={() => {
                    let payload = {
                      vendor_communication_id: record.vendor_communication_id,
                      // is_active: record.is_active,
                      bill_amount: record.bill_amount,
                      approval_amount: record.approval_amount,
                      reference_no: record.reference_no ?? "",
                      due_date: moment(record.due_date).format("MM-DD-YYYY"),
                    }
                    dispatch(updateExpenseBillAttachments(token, payload))
                      .then((res) => {
                        notification("success", "Attachment Updated Successfully");
                        dispatch(getAllExpenseBillAttachments(token, billStatus)).then((res) => {
                          setData(res?.payload?.data);
                        });
                      })
                      .catch((err) => {
                        notification("error", "Failed to Update Attachment");
                      });
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  {/* {
            !record.is_active && (
              <Button
                disabled={record.is_active}
              >
                PROCESSED
              </Button>
            )
          } */}

                  <Button>Save</Button>
                </Popconfirm>
              ) : (
                record.billstatus !== "PAID" && (
                  <EditOutlined
                    style={{ color: "blue", cursor: "pointer", marginLeft: "10px" }}
                    // onClick={() => setIsEdit(true)}
                    onClick={() => {
                      let copyArr = [...data];

                      copyArr.forEach((item) => {
                        if (
                          item.vendor_communication_id ===
                          record.vendor_communication_id
                        ) {
                          item.is_edit = true;
                        }
                      });

                      setData(copyArr);
                    }}
                  />
                )
              )
            }

            <Popconfirm
              title="Are you sure delete this Attachment?"
              onConfirm={() => handleDelete(record)}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined
                style={{ color: "red", cursor: "pointer" }}
              />

            </Popconfirm>
          </Space>

        </>
      ),
    },
  ];



  const handleDelete = (record) => {
    dispatch(deleteExpenseBillAttachments(token, record.vendor_communication_id))
      .then((res) => {
        notification("success", "Attachment Deleted Successfully");
        dispatch(getAllExpenseBillAttachments(token)).then((res) => {
          setData(res?.payload?.data);
        });
      })
      .catch((err) => {
        notification("error", "Failed to Delete Attachment");
      });
  }

  // Upload handler for Antd Upload Component
  const handleFileUpload = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const onFinish = async () => {
    await form
      .validateFields()
      .then((values) => {

        setLoading(true);
        dispatch(uploadExpenseBillAttachments(token, values))
          .then((res) => {
            setLoading(false);
            dispatch(getAllExpenseBillAttachments(token, billStatus)).then((res) => {
              setData(res?.payload?.data);
            })
            form.setFieldsValue({
              vendor: null,
              attachment: null,
              bill_amount: null,
              approval_amount: null,
              reference_no: null,
              due_date: moment(), // today's date
            });
            setFileList([]);
            notification("success", "Upload Successfully");
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      })
      .catch((error) => {
        setLoading(false);
      });
  };


  const downloadExcelFileData = (data) => {
    return data.map((v) => ({
      ID: v.vendor_communication_id,
      "Vendor ID": v.vendor_id,
      "Vendor Name": v.vendor_name,
      "File Name": v.physical_file_name,
      "File Type": v.upload_file_type,
      "Created Date": v.created_date
        ? moment(v.created_date).format("MM-DD-YYYY")
        : "-",
      "Due Date": v.due_date
        ? moment(v.due_date).format("MM-DD-YYYY")
        : "-",
      "Bill Amount": v.bill_amount,
      "Approval Amount": v.approval_amount,
      "Reference No": v.reference_no,
      "Bill Expense Amount": v.bill_expense_amount,
      "Bill Payment Amount": v.bill_payment_amount,
      "Bill Status": v.billstatus,
      "File URL": v.upload_file_url,
    }));
  };

  const fetchVendors = async (token) => {
    try {
      const response = await axios({
        method: "POST",
        url: `${BASEURL}getAll/vendor`,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      });

      if (response?.data?.data) {
        setGetAllVendors(response.data.data);
      }
    } catch (error) {
      console.error(
        "Error fetching vendors:",
        error?.response?.data || error?.message
      );
    }
  };


  useEffect(() => {
    fetchVendors(token);
    dispatch(getAllExpenseBillAttachments(token, billStatus)).then((res) => {
      setData(res?.payload?.data);
    })
  }, [token]);

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Expense Bill Attachment"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="formProduct p-2 d-flex align-items-baseline">
              <Form
                onFinish={onFinish}
                form={form}
                name="control-hooks"
                style={{ width: "50%" }}
                initialValues={{
                  // due_date: moment("MM-DD-YYYY"), // Default aaj ki date select karega
                }}
              >
                <div className="container-fluid pbpx-5 ptpx-5">
                  <Brow>
                    {/* 1. Vendor Field */}
                    <Bcol lg={6} xl={6} xxl={6}>
                      <div>
                        <div className="relative">
                          <Form.Item
                            name="vendor"
                            label="Vendor"
                            labelAlign="left"
                            labelCol={{ span: 6 }}
                            rules={[{ required: true, message: "Vendor is required" }]}
                          >
                            <Select
                              size="small"
                              autoComplete={"nope"}
                              tabIndex={18}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              showSearch
                              allowClear
                              loading={vendor.loading}
                              defaultValue={form.getFieldValue().vendor}
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {getAllVendors?.map((item) => (
                                <Option key={item.vendor_id} value={item.vendor_id}>
                                  {item.vendor_name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>

                    {/* 2. Due Date Field (Default Today - Format MM-DD-YYYY) */}
                    <Bcol lg={6} xl={6} xxl={6}>
                      <div>
                        <div className="relative pl-3">
                          <Form.Item
                            name="due_date"
                            label="Due Date"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            rules={[{ required: true, message: "Due Date is required" }]}
                          >
                            <DatePicker
                              size="small"
                              format="MM-DD-YYYY"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>

                    {/* 3. Bill Amount Field */}
                    <Bcol lg={6} xl={6} xxl={6}>
                      <div>
                        <div className="relative">
                          <Form.Item
                            name="bill_amount"
                            label="Bill Amount"
                            labelAlign="left"
                            labelCol={{ span: 6 }}
                            rules={[{ required: true, message: "Bill Amount is required" }]}
                          >
                            <InputNumber
                              placeholder="Enter Bill Amount"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>

                    {/* 4. Approval Amount Field */}
                    <Bcol lg={6} xl={6} xxl={6}>
                      <div>
                        <div className="relative pl-3">
                          <Form.Item
                            name="approval_amount"
                            label="Approval Amount"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                          >
                            <InputNumber
                              placeholder="Enter Approval Amount"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>

                    {/* 3. Bill Amount Field */}
                    {/* <Bcol lg={6} xl={6} xxl={6}>
                      <div>
                        <div className="relative">
                          <Form.Item
                            name="bill_status"
                            label="Bill Status"
                            labelAlign="left"
                            labelCol={{ span: 6 }}
                            initialValue="UNPAID"
                            // rules={[
                            //   { required: true, message: "Bill Status is required" }
                            // ]}
                          >
                            <Select placeholder="Select Bill Status">
                              <Select.Option value="PAID">PAID</Select.Option>
                              <Select.Option value="UNPAID">UNPAID</Select.Option>
                              <Select.Option value="ALL">ALL</Select.Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol> */}

                    {/* 5. Attachment Field (End par Shifted) */}
                    <Bcol lg={6} xl={6} xxl={6}>
                      <div>
                        <div className="relative">
                          <Form.Item
                            name="attachment"
                            label="Attachment"
                            labelAlign="left"
                            labelCol={{ span: 6 }}
                            rules={[{ required: true, message: "Attachment is required" }]}
                          >
                            <Upload
                              beforeUpload={() => false}
                              fileList={fileList}
                              onChange={handleFileUpload}
                              maxCount={1}
                              showUploadList={{ showRemoveIcon: true }}
                            >
                              <Button
                                size="small"
                                style={{
                                  borderRadius: "4px",
                                  fontWeight: "500",
                                  gap: "4px",
                                }}
                              >
                                <PaperClipOutlined style={{ fontSize: "14px" }} />
                                <span>Attach File</span>
                              </Button>
                            </Upload>
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                  </Brow>
                </div>
              </Form>

              <Button
                htmlType="submit"
                type="primary"
                className="ant-btn ant-btn-primary mrpx-20"
                onClick={onFinish}
              >
                <span className="px-2">Upload</span>
              </Button>


            </div>
          </div>
        )}
      </div>

      <div style={{ marginTop: 10 }}>
        {loading ? (
          <div className="report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
            <Spin size="large" />
          </div>
        ) : data.length > 0 ? (
          <>
            <Select defaultValue="UNPAID" placeholder="Select Bill Status" onChange={(value) => {
              setBillStatus(value);
              dispatch(getAllExpenseBillAttachments(token, value)).then((res) => {
                setData(res?.payload?.data);
              })
            }}>
              <Select.Option value={null}>ALL</Select.Option>
              <Select.Option value="PAID">PAID</Select.Option>
              <Select.Option value="UNPAID">UNPAID</Select.Option>
            </Select>
            <Table
              title={() => (
                <CSVLink
                  filename="Expense-Bill-Attachment.csv"
                  data={downloadExcelFileData(data)}
                >
                  Download Excel
                </CSVLink>
              )}
              ref={tableRef}
              size="small"
              bordered={false}
              type="company"
              perPage={15}
              scroll={{ x: "max-content" }}
              dataSource={data}
              columns={columns}
              loading={loading}
              onRow={(record) => {
                const today = moment().startOf("day");
                const dueDate = record.due_date
                  ? moment(record.due_date).startOf("day")
                  : null;

                const isPastDue = dueDate && dueDate.isBefore(today);
                const isUnpaid = record.billstatus === "UNPAID";

                return {
                  style: {
                    backgroundColor:
                      isPastDue && isUnpaid ? "#ffccc7" : "transparent",
                  },
                };
              }}
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 100,
                pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
              }}
            />
          </>
        ) : (
          <div
            style={{
              backgroundColor: "#CCCCCC",
              borderWidth: "1pt",
              borderStyle: "Dashed",
              fontWeight: "bold",
              height: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            No record(s)
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpenseBillAttachment;